<template src="./SplitRouteModal/SplitRouteModal.html"></template>
<script>
import { Webapi } from '@/Webapi'
import DropDown from '@/widgets/DropDown'
import DriverSelector from '@/widgets/DriverSelector'

export default {
    name: 'SplitRouteModal',
    components: {
        DropDown,
        DriverSelector,
    },
    props: {
        routeId: Number,
        stops: Array, // {id, sequence}
        uiData: Object,
        onClose: Function,
        resync: Function,
        vehicleTypes: Array,
    },
    data: () => ({
        status: 'PRE',
        selectedServiceTime: null,
        selectedReason: null,
        selectedParty: null,
        crossdockSequence: null,
        invalidCrossdockSequence: false,
        selectedCourierId: null,
        selectedDriverId: null,
        createdRouteId: null,
        errorMessages: [],
        showCouldNotAssignDriver: false,
        selectedVehicleType: {
            displayName: 'Car',
            value: 'CAR',
        },
    }),
    computed: {
        isSubmittable() {
            return (
                this.selectedServiceTime !== null &&
                this.selectedReason !== null &&
                this.selectedVehicleType !== null &&
                this.selectedParty !== null &&
                (this.crossdockSequence || '').trim() !== '' &&
                !this.invalidCrossdockSequence
            )
        },
        maxCrossdockSequence() {
            return this.stops.map((stop) => stop.sequence).sort()[0] - 1
        },
    },

    methods: {
        onServiceTimeUpdated(serviceTime) {
            this.selectedServiceTime = serviceTime
        },
        onVehicleTypesUpdated(vehicleType) {
            this.selectedVehicleType = vehicleType
        },
        onReasonUpdated(reason) {
            this.selectedReason = reason
        },
        onPartyUpdated(party) {
            this.selectedParty = party
        },
        onCrossdockSequenceChange() {
            if (this.crossdockSequence === '') {
                this.invalidCrossdockSequence = false
                return
            }
            if (
                this.crossdockSequence > this.stops.map((stop) => stop.sequence).sort()[0] - 1 ||
                this.crossdockSequence < 1
            ) {
                this.invalidCrossdockSequence = true
            } else {
                this.invalidCrossdockSequence = false
            }
        },
        onSplit() {
            const stopIds = this.stops.map((stop) => stop.id)
            this.status = 'IN_PROGRESS'
            const driver = !this.selectedDriverId
                ? null
                : {
                      courierId: this.selectedCourierId,
                      driverId: this.selectedDriverId,
                  }
            Webapi()
                .splitRoute(
                    this.routeId,
                    stopIds,
                    this.crossdockSequence,
                    this.selectedReason.value,
                    this.selectedServiceTime.value,
                    this.selectedVehicleType.value,
                    this.selectedParty.value,
                    driver,
                )
                .then((json) => this.onSplitResponse(json))
        },
        onSplitResponse(response) {
            this.status = response.status
            this.errorMessages = response.messages
            if (response.payload) {
                this.showCouldNotAssignDriver = response.payload.assignDriverFailed
                this.createdRouteId = response.payload.routeId
            }
            this.resync()
        },
        onDriverSelected(courierId, driverId) {
            this.selectedCourierId = courierId
            this.selectedDriverId = driverId
        },
    },
}
</script>
<style lang="scss" scoped>
.split-loader-message-wrapper {
    min-height: 100px;
}

.modal-card-body {
    overflow: visible;
}

.split-modal {
    max-height: none;
    overflow: visible;
}

.loading {
    margin-top: 20px;
    width: 100%;
    height: 70px;
}

label {
    margin-top: 15px;
}

.result-message {
    margin-top: 25px;
}

.error-list {
    list-style-type: disc;
    margin-left: 40px;
}

.split-input-row {
    display: flex;
}

.split-reason-input {
    width: 60%;
}

.split-party-input {
    flex: 1;
}

.split-servicetime-input {
    flex: 1;
}

.split-sequence-input {
    flex: 1;
}

.sequence-tag {
    margin-bottom: -5px;
}

.split-input-spacer {
    width: 10px;
}
</style>
